// Per-account brand thumbnail, seeded server-side into window.globalConfig.
// When set, the unread-badge swap and the visibilitychange "clear badge"
// handler both restore to this URL instead of the hardcoded upstream
// /favicon-${size}.png — otherwise tab-switch wipes per-account branding.
const brandThumbnail = () => window.globalConfig?.LOGO_THUMBNAIL || null;

export const showBadgeOnFavicon = () => {
  const favicons = document.querySelectorAll('.favicon');

  favicons.forEach(favicon => {
    const newFileName = `/favicon-badge-${favicon.sizes[[0]]}.png`;
    favicon.href = newFileName;
  });
};

export const initFaviconSwitcher = () => {
  const favicons = document.querySelectorAll('.favicon');

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      const branded = brandThumbnail();
      favicons.forEach(favicon => {
        favicon.href = branded || `/favicon-${favicon.sizes[[0]]}.png`;
      });
    }
  });
};
